<template>
  <v-app>
    <v-main>
      <euro-calc />
    </v-main>
  </v-app>
</template>

<script>
import EuroCalc from './components/EuroCalc.vue'

export default {
  name: 'App',

  components: {
    EuroCalc
  },

  data: () => ({
    //
  }),
};
</script>
